const WEBSITE = "https://castory-ai.com";
const APP_HOME = "https://castory-app.com/";
const APP_TOUR = APP_HOME + "tour";
const APP_PLAN = APP_HOME + "plan";
const APP_TASKS = APP_HOME + "tasks";

export { APP_HOME, APP_TOUR, APP_PLAN, APP_TASKS, WEBSITE };
